export default __webpack_public_path__ + "static/media/decrease.66e5cc13.svg";